import { UtilisateurInscriptionDto } from '@common/services';
import { areEveryFieldsValuesSame, toSavedFile } from '@common/utils';
import { useAppDispatch } from '../../../hooks/store.hook';
import {
  setAdmin1AndRepresentantAreSame,
  setFichierAttestation,
  setFichierDelegation,
  setUtilisateurAdmin1,
  setUtilisateurAdmin2,
  setUtilisateurDelegataire,
  setUtilisateurRepresentant,
} from '../../../stores/inscription.slice';
import { useGetInscriptionFichiers } from './use-get-inscription-fichiers.hook';
import { useGetInscriptionUtilisateurs } from './use-get-inscription-utilisateurs.hook';

export function usePrefillInscription() {
  const dispatch = useAppDispatch();

  const { getInscriptionUtilisateurs } = useGetInscriptionUtilisateurs();
  const { getInscriptionFichiers } = useGetInscriptionFichiers();

  function areAdmin1AndRepresentantAreSame(admin1: UtilisateurInscriptionDto, representant: UtilisateurInscriptionDto) {
    return areEveryFieldsValuesSame(admin1, representant, ['nom', 'prenom', 'travail', 'email', 'telephone']);
  }

  return {
    prefillInscription: async (organismeId: number) => {
      try {
        const { admin1, admin2, representant, delegataire } = await getInscriptionUtilisateurs(organismeId);

        dispatch(setUtilisateurAdmin1(admin1 ?? null));
        dispatch(setUtilisateurAdmin2(admin2 ?? null));

        dispatch(setUtilisateurRepresentant(representant ?? null));
        dispatch(setUtilisateurDelegataire(delegataire ?? null));

        dispatch(setAdmin1AndRepresentantAreSame(areAdmin1AndRepresentantAreSame(admin1, representant)));
      } catch (err) {
        if (err.status === 403) throw 'CANNOT_PREFILL';
      }

      try {
        const { attestation, delegation } = await getInscriptionFichiers(organismeId);

        dispatch(setFichierAttestation((attestation) ? toSavedFile(attestation) : null));
        dispatch(setFichierDelegation((delegation) ? toSavedFile(delegation) : null));
      } catch (err) {
        if (err.status === 403) throw 'CANNOT_PREFILL';
      }
    },
  };
}